import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpApiService } from '@recruitee/http';
import { TalentPool } from '@recruitee/http-types';
import { OfferScope } from '@recruitee/offers-data';

@Injectable({
  providedIn: 'root',
})
export class TalentPoolsByCompanyHttpService {
  constructor(private httpApi: HttpApiService) {}

  public fetchOne$(
    id: string,
    scope = OfferScope.Active,
  ): Observable<{ talentPools: TalentPool[]; id: string }> {
    const url = `${this.httpApi.appConfig.apiUrl}c/${id}/talent_pools?scope=${scope}`;

    return this.httpApi.get(url, undefined, { skipURLBuild: true }).pipe(
      map(response => ({
        talentPools: response.talentPools,
        id,
      })),
    );
  }
}
